import React from 'react';
import { Toaster } from 'sonner';
import { CursorGlow } from './components/CursorGlow';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Work } from './components/Work';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div dir="rtl" className="bg-[#0a0a0f] min-h-screen text-white font-sans selection:bg-[#7c5cfc] selection:text-white" data-id="element-0">
      <div className="noise-overlay" data-id="element-1" />
      <CursorGlow data-id="element-2" />
      <Toaster position="bottom-left" dir="rtl" data-id="element-3" />

      <Nav data-id="element-4" />
      <main data-id="element-5">
        <Hero data-id="element-6" />
        <Stats data-id="element-7" />
        <Work data-id="element-8" />
        <Services data-id="element-9" />
        <Process data-id="element-10" />
        <Team data-id="element-11" />
        <Testimonials data-id="element-12" />
        <CTA data-id="element-13" />
        <Contact data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}